// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************

const GET_FINANCIAL_PAYROLL_SUCCESS = "GET_FINANCIAL_PAYROLL_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getFileSuccess(payload) {
  return {
    type: GET_FINANCIAL_PAYROLL_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* financialPayrolls **********************************************************************
/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function checkFile(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Payroll")) {
      api
        .post("/financial/payroll/check_file", {
          data: {
            props: {
              year: data.year,
              month: data.month,
            },
          },
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(res);
          // const link = document.createElement("a");
          // link.href = url;
          if (res.type.includes("pdf")) {
            dispatch(_getFileSuccess(url));
            callback(undefined, url);
          } else {
            dispatch(_getFileSuccess("اطلاعاتی جهت نمایش موجود نیست!"));
            callback(undefined, "اطلاعاتی جهت نمایش موجود نیست!");
          }
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.payroll",
              "payroll"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    payroll: {},
  },
  action
) {
  switch (action.type) {
    case GET_FINANCIAL_PAYROLL_SUCCESS:
      return Object.assign({}, state, {
        payroll: action.payload,
      });
    default:
      return state;
  }
}
